<template>
    <div class="mb-2">
        <p class="mb-3 mt-1">Add this LTI Link to your LMS to bring learners directly to this learning experience.</p>
        <copy-link-input ref="lmsEmbedLink" v-model="ltiLaunchLink" class="mb-3"></copy-link-input>
        <div v-if="organizationLMSGradePassbackEnabled">
            <base-form
                class="mt-1"
                v-model="linkSettings"
                :fields="linkFormFields"
                :condensedStyle="true"
            ></base-form>
        </div>
        <div class="mt-4">
            <lms-instructions :default-vendor-type="organizationLmsDefaultVendorType"></lms-instructions>
        </div>
    </div>
</template>

<script>
import CopyLinkInput from "@/components/CopyLinkInput"
import LmsInstructions from "@/components/LmsInstructions"
import BaseForm from "@/components/BaseForm"
import { ltiResourceLinkFormFields } from "@/assets/js/settings.js"

export default {
    name: "LtiLaunchForm",
    props: {
        caseObj: {
            type: Object,
            required: true,
        },
    },
    components: {
        CopyLinkInput,
        LmsInstructions,
        BaseForm,
    },
    data() {
        return {
            enableLTIGradePassback: true,
            enableLTIPDFPassback: false,
            enableLTIManualGrading: false,
            linkSettings: {
                enableGradePassback: true,
                allowMultipleAttempts: true,
                allowMultipleGradePassback: true,
                requireManualGrading: false
            },
            // Modify the form fields to use the description field, instead of the subtext field,
            // for a more compact display.
            linkFormFields: ltiResourceLinkFormFields.map(f => {
                return {
                    ...f,
                    type: "checkbox",
                    description: f.subtext,
                    subtext: ""
                }
            })
        }
    },
    watch: {
        linkSettings: {
            handler: function () {
                this.reset()
            },
            deep: true,
        }
    },
    computed: {
        organizationLmsDefaultVendorType() {
            return this.$store.getters.organizationDetails.lms_default_vendor_type || "d2l"
        },
        ltiLaunchLink() {
            let link = `${window.location.origin}/scenarios/?scenarioID=${this.caseObj.id}&lmsLaunchID=${this.caseObj.lms_launch_id}`
            if (this.organizationLMSGradePassbackEnabled) {
                link += `&passbackResults=${this.linkSettings.enableGradePassback}&requireManualGrading=${this.linkSettings.requireManualGrading}&allowMultipleAttempts=${this.linkSettings.allowMultipleAttempts}&allowMultipleGradePassback=${this.linkSettings.allowMultipleGradePassback}`
            }
            return link
        },
        organizationLMSGradePassbackEnabled() {
            return this.$store.getters.organizationLMSGradePassbackEnabled
        },
    },
    methods: {
        // Reset the copy-state of the link.
        reset() {
            this.$refs.lmsEmbedLink.reset()
        },
        // Reset the form to its initial state.
        resetForm() {
            this.linkSettings = {
                enableGradePassback: true,
                allowMultipleAttempts: true,
                allowMultipleGradePassback: true,
                requireManualGrading: false
            }
            this.reset()
        },
    },
}
</script>

<style>
</style>